import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import OverviewDashboardLayer from "../components/dashboards/OverviewDashboardLayer";

const OverviewDashboardPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Overview">
        {/* OverviewDashboardLayer */}
        <OverviewDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default OverviewDashboardPage;
